export const NEO_GAS_TOKEN_ADDRESS='0xd2a4cff31913016155e38e474a2c06d08be276cf';